export const viewUsersFiltersConstants = Object.freeze({
  USERS: {
    LABEL: "Sort By",
    placeHolder: "Sort By",
    options: [
      { value: "DESC", label: "Descending" },
      { value: "ASC", label: "Ascending" },
    ],
  },
  ORDER_STATUS: {
    LABEL: "Current Order Status",
    placeHolder: "Current Order Status",
    options: [
      { value: "PRESCRIBED", label: "Prescribed" },
      { value: "DELIVERED", label: "Delivered" },
    ],
  },
});
export const viewUsersTableDesktopHeaders = (): DesktopTableHeaderOption[] => {
  return [
    {
      text: "Customer",
      span: 3,
      isCheckBox: false,
    },
    {
      text: "Address",
      span: 4,
      isCheckBox: false,
    },
    {
      text: "Date Signed Up",
      span: 3,
      isCheckBox: false,
    },
    {
      text: "Date of last order",
      span: 3,
      isCheckBox: false,
    },
    {
      text: "Formula",
      span: 4,
      isCheckBox: false,
    },
    {
      text: "Order Status",
      span: 3,
      isCheckBox: false,
    },
    {
      text: "",
      span: 3,
      isCheckBox: true,
      checkboxId: "CHECK_ALL",
      extraClass: "put-checkbox-in-center",
    },
  ];
};
export const userOrderHistoryTableDesktopHeaders =
  (): DesktopTableHeaderOption[] => {
    return [
      {
        text: "Pain level & Order date",
        span: 4,
        isCheckBox: false,
      },
      {
        text: "Prescribed formula",
        span: 7,
        isCheckBox: false,
      },
      {
        text: "Directions",
        span: 5,
        isCheckBox: false,
      },
      {
        text: "Order # & Status",
        span: 4,
        isCheckBox: false,
      },

      {
        text: "",
        span: 4,
        isCheckBox: true,
        checkboxId: "CHECK_ALL",
        extraClass: "put-checkbox-in-center",
      },
    ];
  };

export const formatAddress = (address: IUserAddress): string => {
  if (!address) return "Address not available";

  const { street1, street2, city, state, zipCode } = address;

  const parts = [
    street1,
    street2,
    city && state ? `${city}, ${state}` : city || state,
    zipCode,
  ].filter(Boolean); // Removes null or empty values

  return parts.length > 0 ? parts.join(", ") : "Address not available";
};
